/**
 * Projects (Zigzag) — "Load more" reveal.
 *
 * The block renders the first N project cards directly and stashes the rest in a
 * <template data-zigzag-more>. Each click moves the next `per_page` cards from the
 * template into the grid (their inline `--ga` grid-area continues the stagger) and
 * fades them in. When the template is empty the button is removed.
 */
export function projectsLoadMore() {
  document.querySelectorAll('[data-zigzag-grid]').forEach((root) => {
    const btn = root.querySelector('[data-zigzag-load-more]');
    const grid = root.querySelector('[data-zigzag-items]');
    const tpl = root.querySelector('template[data-zigzag-more]');
    if (!btn || !grid || !tpl) return;

    const perPage = parseInt(btn.dataset.perPage, 10) || 6;

    btn.addEventListener('click', () => {
      const pool = tpl.content;
      let moved = 0;
      while (moved < perPage && pool.firstElementChild) {
        const node = pool.firstElementChild;
        pool.removeChild(node);
        node.classList.add('is-new');
        grid.appendChild(node);
        moved += 1;
      }
      if (!pool.firstElementChild) {
        // Nothing left — drop the whole "more" row (button + wrapper).
        (btn.closest('.zigzag-projects__more') || btn).remove();
      }
    });
  });
}
